import styled from "@emotion/styled";
import { DeviceType, useDeviceType } from "hooks/useDeviceType";
import { ProfileIcon } from "../../general/UserIcons/ProfileIcon/ProfileIcon";

export const NavbarProfilePicture = () => {
  const isTablet = useDeviceType() === DeviceType.Tablet;
  return (
    <IconContainer>
      <ProfileIcon size={isTablet ? 56 : 80} borderRadius="14px" withBackground={false} />
    </IconContainer>
  );
};

// Sub-components

const IconContainer = styled.div`
  border-radius: 20px;
  margin-bottom: 10px;
`;
